// Override Settingsconst
const boostPFSFilterConfig = {
	general: {
		limit: window.boostPFSConfig.custom.products_per_page,
		loadProductFirst: false,
		refineByFromFilter: false,
		colorOptionFilterName: 'farbe',
		filterHorizontalColumn: 'full'
	}
};

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function () {
	let soldOut = false,
		images = [],
		customAppColors = boostPFSAppConfig.swatch_settings;

	BoostPFS.inject(this);

	const modifiers = {
		hidden: "hidden"
	};

	const classes = {
		mediaSingle: "product-card__media--single"
	};

	function setAttributes(el, attrs) {
		Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
	}

	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return removeProtocol(src);
		}

		const match = src.match(/\.(jpg|jpeg|webp|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

		if (match) {
			const prefix = src.split(match[0]);
			const suffix = match[0];

			return removeProtocol(`${prefix[0]}_${size}${suffix}`);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	function imageSize(src) {
		const match = src.match(
			/.+(_((?:pico|icon|thumb|small|compact|medium|large|grande))|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
		);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/* For Filter Setting Layout */
	Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

	// const banners = boostPFSConfig.collectionBanners;

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		hasOnlyDefaultVariant = data.variants.length === 1;

		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock

		// Convert images to array
		images = data.images_info;

		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) {
			data = this.data;
		}

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		return this.buildTemplate(data);
	};
	/************************** END BUILD PRODUCT LIST **************************/

	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	ProductGridItem.prototype.buildTemplate = function (product, variant) {
		let template = boostPFSTemplate.productGridItemHtml.replace(/{{productId}}/g, product.id);

		let imagesHtml = this.buildImages(product, variant);
		let titleHtml = this.buildProductTitle(product);
		let priceHtml = this.buildProductPrice(product);
		let buttonCartHtml = this.buildAddToCartButton(product);
		this.buildColorSwatchers(product, variant);


		template = template.replace(/{{productImages}}/g, imagesHtml);
		template = template.replace(/{{productTitle}}/g, titleHtml);
		template = template.replace(/{{productPrice}}/g, priceHtml);
		template = template.replace(/{{productCartButton}}/g, buttonCartHtml);

		// Add main attribute (Always put at the end of this function)
		template = template.replace(/{{itemId}}/g, product.id);
		template = template.replace(/{{itemTitle}}/g, product.title);
		template = template.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(product));

		return template;
	};

	ProductGridItem.prototype.buildImages = function (product) {
		const productUrl = Utils.buildProductItemUrl(product);

		const secondaryImage = () => {
			let secondaryImage = product.images_info[1];

			if (secondaryImage) {
				let src = secondaryImage.src;
				let alt = secondaryImage.alt ?? product.title;

				return `<picture>
					<img
						src="${getSizedImageUrl(src, "650x")}"
						alt="${alt}"
						class="product-card__image product-card__image--secondary js-collection-product-card-secondary-image"
						loading="lazy"
					/>
				</picture>

				<video
					playsinline
					autoplay
					loop
					muted
					alt=""
					class="product-card__image product-card__image--secondary hidden js-collection-product-card-secondary-video"
					src=""
				></video>`;
			}
			else {
				return `<picture>
					<img
						src=""
						srcset=""
						alt=""
						class="product-card__image product-card__image--secondary hidden js-collection-product-card-secondary-image"
						loading="lazy"
					/>
				</picture>
				<video
					playsinline
					autoplay
					loop
					muted
					alt=""
					class="product-card__image product-card__image--secondary hidden js-collection-product-card-secondary-video"
					src=""
				></video>`;
			}
		};

		const featuredImage = () => {
			let image = Utils.getFeaturedImage(images).replace((imageSize(Utils.getFeaturedImage(images))), "");
			if (!image) {
				image = boostPFSAppConfig.general.no_image_url;
			}

			let src,
				alt,
				media = [...product.media],
				featuredData;

			if (!media.length) {
				return "";
			}

			featuredData = media[0];

			if (featuredData.mediaContentType.toLowerCase() === "video" ) {
				featuredData.sources.forEach(data => {
					src += `<source
								src="${data.url}"
							/>`;
				});

				return `<video
							playsinline
							muted
							autoplay="autoplay"
							loop="loop"
							class="product-card__image product-card__image--primary js-collection-product-card-featured-video"
						>
							${src}
						</video>

						<picture>
							<img
								src=""
								srcset=""
								alt="${alt}"
								class="product-card__image product-card__image--primary hidden js-collection-product-card-featured-image"
								loading="lazy"
							/>
						</picture>`;
			} else {
				src = image;
				alt = image.alt ?? product.title;

				return `<picture>
							<img
								src="${getSizedImageUrl(src, "650x")}"
								alt="${alt}"
								class="product-card__image product-card__image--primary js-collection-product-card-featured-image"
								loading="lazy"
							/>
						</picture>
						<video
							playsinline
							autoplay
							loop
							muted
							alt=""
							class="product-card__image product-card__image--primary hidden js-collection-product-card-featured-video"
							src=""
						></video>`;
			}
		};

		return `<a href="${productUrl}" class="product-card__image-wrapper">
					${secondaryImage()}
					${featuredImage()}
				</a>`;
	};

	ProductGridItem.prototype.buildProductTitle = function (product) {
		let { title } = product;
		let url = Utils.buildProductItemUrl(product);

		let productTitleHtml = `<a href="${url}" class="js-collection-product-link">${title}</a>`;

		return `${productTitleHtml}`;
	};

	ProductGridItem.prototype.buildProductPrice = function (product) {
		let { price_min, compare_at_price_min } = product;

    const priceHtml = `<span>${Utils.formatMoney(price_min)}</span>`;
    const comparePriceHtml = compare_at_price_min > price_min
      ? `<span class="product-card__compare-price">${Utils.formatMoney(compare_at_price_min)}</span>`
      : '';

		return comparePriceHtml + priceHtml;
	};

	ProductGridItem.prototype.buildAddToCartButton = function (product) {
		let url = Utils.buildProductItemUrl(product);

		if (!url) {
			return null;
		}

		let	label = boostPFSThemeConfig.label.add_to_cart;

		let buttonCartHtml = `
				<a
					class="button button--primary product-card__button js-collection-product-link"
					href="${url}"
				>
					${label}
				</a>`;

		return `${buttonCartHtml}`;
	};
	ProductGridItem.prototype.getStitchProductJSON = function (product) {
		let tags = product.tags;

		if (!tags.length && !tags.includes("stitch:")) {
			return null;
		}

		let getColorGroupName;

		tags.forEach(tag => {
			if(tag.includes("stitch:")){
				getColorGroupName = tag;
			}
		});

		const sessionStorageData = window.sessionStorage.getItem(getColorGroupName);

		if (sessionStorageData) {
			const structurizedStitchProductsData = JSON.parse(sessionStorageData);

			return new Promise((resolve) => {
				resolve(structurizedStitchProductsData);
			});
		}
		return new Promise((resolve) => {
			fetch(
				`/collections/all/${getColorGroupName}?view=color-swatchers-group`
			).then((data) => {
				if (data.status === 404) {
					return null;
				}

				return data.text();

			}).then(getJson => {
				const html = document.createElement("div");
				html.innerHTML = getJson;
				const rawJSON = html.querySelector("[data-color-group]");

				return JSON.parse(rawJSON.innerHTML);
			}).then(stitchProductsJSON => {
				window.sessionStorage.setItem(getColorGroupName, JSON.stringify(stitchProductsJSON));
				resolve(stitchProductsJSON);
			});
		});
	};
	ProductGridItem.prototype.buildColorSwatchers = async function (product) {
			const responseData = await this.getStitchProductJSON(product);

			const colorLabel = [
				"color",
				"colour",
				"couleur",
				"colore",
				"farbe",
				"색",
				"色",
				"fxärg",
				"farve"
			];

			let colorSwatches = "";

			let button = "";

			let productCard = document.querySelector(`[data-collection-product="${product.id}"]`);
			let currentProductId = productCard.getAttribute("data-collection-product");

			Object.values(responseData).forEach((productItem) => {
				let colorOption = null;

				const productItemId = productItem.id;
				const currentColor = productItem.current_color;

				let activeClass = "";

				productItem.options_with_values.forEach((option) => {
					if (colorLabel.includes(option.name.toLowerCase())) {
						colorOption = option;
					}
				});

				if (!colorOption) {
					return null;
				}

				const currentProductColor = responseData[currentProductId]?.current_color;
				colorOption.values.forEach((color) => {
					const lowerCasedColor = color.toLowerCase();

					if (lowerCasedColor === currentProductColor) {
						activeClass = "active";
					}
				});

				const currentColorHandleized = currentColor.toLowerCase().replace(' ', '');

				/* Add color to swatcher from app (url, hex) or current color */
				const swatcherColor = `background-color: ${currentColorHandleized}`;

				const swatcherImage = getFileImageUrl(`swatch_${currentColorHandleized}.png`);
				const swatcherImageJpg = getFileImageUrl(`swatch_${currentColorHandleized}.jpg`);

				const swatcherStyles = `
					background-color: ${swatcherColor};
					background-image: url(${swatcherImage}), url(${swatcherImageJpg});
				`;

				button = `
					<div class="product-card__swatch-wrapper ${activeClass} js-collection-color-swatch-wrapper">
						<button
							class="product-card__swatch ${activeClass} js-collection-color-swatch"
							style="${swatcherStyles}"
							id="${productItemId}"
							data-product-id="${productItemId}"
							value="${currentColor}"
						>
						</button>
					</div>
				`;

				colorSwatches += button;
			});

			[...productCard.querySelectorAll("[data-product-swatches-container]")].forEach(container => {
				container.innerHTML = colorSwatches;
			});

			const colorSwatchesArray = [...productCard.querySelectorAll(".js-collection-color-swatch")];
			if (!colorSwatchesArray.length) {
				return "";
			}

			const productLinks = [...productCard.querySelectorAll(".js-collection-product-link")];
			const mediaContainer = productCard.querySelector(".js-collection-product-card-media-container");
			const cardTitles = [...productCard.querySelectorAll(".js-collection-card-title")];
			const cardPrices = [...productCard.querySelectorAll("[data-prices]")];

			colorSwatchesArray.forEach(swatch => {
				swatch.addEventListener("click", () => {
					if (swatch.classList.contains("active")) {
						return null;
					}

					const currentProductId = swatch.getAttribute("data-product-id");
					const currentProductData = responseData[currentProductId];
					const productMedia = currentProductData.media;

					if (productMedia.secondary_media.src) {
						mediaContainer.classList.remove(classes.mediaSingle);
					} else {
						mediaContainer.classList.add(classes.mediaSingle);
					}

					productLinks.forEach(link => {
						link.setAttribute("href", currentProductData.url);
					});

					cardTitles.forEach(title => {
						title.innerText = currentProductData.title;
					});

					cardPrices.forEach(price => {
            const priceHtml = `<span>${currentProductData.price}</span>`;
            const comparePriceHtml = currentProductData.compare_at_price
              ? `<span class="product-card__compare-price">${currentProductData.compare_at_price}</span>`
              : '';

            price.innerHTML = comparePriceHtml + priceHtml;
					});

					const activeSwatches = [...productCard.querySelectorAll(".js-collection-color-swatch.active")];

					activeSwatches.forEach(swatch =>{
						swatch.classList.remove("active");

						const swatchWrapper = swatch.closest(".js-collection-color-swatch-wrapper");
						swatchWrapper.classList.remove("active");
					});

					const currentActiveSwatches = [...productCard.querySelectorAll(`[data-product-id="${currentProductId}"]`)];

					currentActiveSwatches.forEach(swatch => {
						swatch.classList.add("active");

						const swatchWrapper = swatch.closest(".js-collection-color-swatch-wrapper");
						swatchWrapper.classList.add("active");
					});

					const featuredVideo = productCard.querySelector(".js-collection-product-card-featured-video");
					const featuredImage = productCard.querySelector(".js-collection-product-card-featured-image");
					const secondaryVideo = productCard.querySelector(".js-collection-product-card-secondary-video");
					const secondaryImage = productCard.querySelector(".js-collection-product-card-secondary-image");

					Object.values(productMedia).forEach((mediaElement, index) => {
						const mediaElementObject = mediaElement.src;

						if (!mediaElementObject) {
							return null;
						}

						if (mediaElement.type === "video") {
							switch (index) {
								case 0:
									featuredVideo.classList.remove(modifiers.hidden);
									featuredImage.classList.add(
										modifiers.hidden
									);
									setAttributes(featuredVideo, {
										src: mediaElementObject.sources.at(-2).url,
										alt: mediaElementObject.alt
									});

									break;
								case 1:
									secondaryVideo.classList.remove(modifiers.hidden);
									secondaryImage.classList.add(
										modifiers.hidden
									);

									setAttributes(secondaryVideo, {
										src: mediaElementObject.sources.at(-2).url,
										alt: mediaElementObject.alt
									});

									break;
							}
						} else {
							const resizedMediaSrc = getSizedImageUrl(
								mediaElementObject.src,
								"650x"
							);

							switch (index) {
								case 0:
									featuredImage.classList.remove(
										modifiers.hidden
									);
									featuredVideo.classList.add(modifiers.hidden);
									featuredVideo.pause();

									setAttributes(featuredImage, {
										alt: mediaElementObject.alt,
										src: resizedMediaSrc
									});

									break;
								case 1:
									secondaryImage.classList.remove(
										modifiers.hidden
									);
									secondaryVideo.classList.add(modifiers.hidden);
									secondaryVideo.pause();
									setAttributes(secondaryImage, {
										alt: mediaElementObject.alt,
										src: resizedMediaSrc
									});

									break;
							}
						}
					});
				});
			});
		return "";
	};

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		if (currentPage > totalPage) {
			window.location.href = "/404";
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage >= 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage > 0) {
			beforeCurrentPageArr.unshift('Page');
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage <= totalPage) {
			afterCurrentPageArr.push('of');
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == 'of') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	/************************** END BUILD TOOLBAR **************************/

	/************************** START CUSTOMIZATIONS **************************/
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		jQ('[data-product-counter]').html(this.totalProduct);
	};

	// Build Additional Elements
	FilterResult.prototype.afterRender = function (data, event) {
		const selectors = {
			products: '[data-collection-products]',
			input: '.js-search-result-input',
			button: '.js-search-result-close',
			paginationButton: '.pagination__item--prev'
		};

		const modifiers = {
			loading: 'boost-loading',
			button_hidden: 'button-hidden',
			active: 'active',
			disabled: 'pagination__item--disabled'
		};

		jQ(selectors.products).removeClass(modifiers.loading);

		function searchPageInputForm() {
			if (!jQ(selectors.input)) {
				return null;
			}

			if (jQ(selectors.input).val()?.length) {
				jQ(selectors.input).parent().addClass(modifiers.active);
			}

			jQ(document).on('input keypress', selectors.input, () => {
				jQ(selectors.input).siblings().removeClass(modifiers.button_hidden);
				jQ(selectors.input).parent().removeClass(modifiers.active);
			});

			jQ(document).on('click', selectors.button, () => {
				jQ(selectors.button).parent().removeClass(modifiers.active);
				jQ(selectors.input).val("");
			});
		}

		searchPageInputForm()

		let currentPage = parseInt(Globals.queryParams.page);
		if (currentPage === 1) {
			jQ(selectors.paginationButton).addClass(modifiers.disabled);
		} else {
			jQ(selectors.paginationButton).removeClass(modifiers.disabled);
		}
	};
	/************************** END CUSTOMIZATIONS **************************/

	/************************** START HELPERS **************************/
	function getFileImageUrl(filename) {
		return boostPFSThemeConfig.helpers.file_image_url.replace("%filename%", filename);
	}
	/************************** END HELPERS **************************/
})();
